import { render, staticRenderFns } from "./antiIndulgedLogin.vue?vue&type=template&id=5bd44ada"
import script from "./antiIndulgedLogin.vue?vue&type=script&lang=js"
export * from "./antiIndulgedLogin.vue?vue&type=script&lang=js"
import style0 from "./antiIndulgedLogin.vue?vue&type=style&index=0&id=5bd44ada&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports